import React from 'react'
import { func } from 'prop-types'
import {
  Icon,
  Button,
  Color,
  Card,
  Grid
} from '@cobalt/cobalt-react-components'
import MechanismOption from './MechanismOption'
import {
  MFA_SETTINGS_RECOVERY_CODES_TITLE,
  MFA_SETTINGS_RECOVERY_CODES_DESCRIPTION,
  MFA_SETTINGS_RECOVERY_CODES_RENEW
} from '../../constants/ui.labels'
import { SETTINGS_CARD_BACKGROUND_COLOR } from '../../constants/colors'

const settings = {
  icon: Icon.VPN_KEY,
  name: MFA_SETTINGS_RECOVERY_CODES_TITLE,
  description: MFA_SETTINGS_RECOVERY_CODES_DESCRIPTION,
  isActive: false,
  defaultColor: Color.orange[600]
}

const RenewButton = ({ onRenew }) => (
  <Button secondary onClick={onRenew} small fullWidth>
    {MFA_SETTINGS_RECOVERY_CODES_RENEW}
  </Button>
)

const RecoveryCodesOption = props => (
  <Card backgroundColor={SETTINGS_CARD_BACKGROUND_COLOR}>
    <Card.Content fullWidth noPadding>
      <div style={{ margin: '1rem 0' }}>
        <Grid>
          <Grid.Group>
            <Grid.Column>
              <MechanismOption {...settings} />
            </Grid.Column>
            <Grid.Column small="hide" all="min">
              <RenewButton {...props} />
            </Grid.Column>
          </Grid.Group>
          <Grid.Group>
            <Grid.Column large="hide" medium="hide">
              <div style={{ marginTop: '1rem', width: '100%' }}>
                <RenewButton {...props} />
              </div>
            </Grid.Column>
          </Grid.Group>
        </Grid>
      </div>
    </Card.Content>
  </Card>
)

RecoveryCodesOption.propTypes = {
  onRenew: func.isRequired
}

RenewButton.propTypes = {
  onRenew: func.isRequired
}

export default RecoveryCodesOption
